var A = /* @__PURE__ */ ((E) => (E.dynamic = "dynamic", E.fixed = "fixed", E))(A || {}), R = /* @__PURE__ */ ((E) => (E.DAY = "DAY", E.MONTH = "MONTH", E.YEAR = "YEAR", E.OTHER = "OTHER", E))(R || {}), Y = /* @__PURE__ */ ((E) => (E.TODAY = "TODAY", E.YESTERDAY = "YESTERDAY", E.WEEK = "WEEK", E.MONTH = "MONTH", E.QUARTER = "QUARTER", E.YEAR = "YEAR", E))(Y || {}), T = /* @__PURE__ */ ((E) => (E.DAY = "DAY", E.WEEK = "WEEK", E.MONTH = "MONTH", E.QUARTER = "QUARTER", E.YEAR = "YEAR", E))(T || {});
export {
  R as Category,
  T as Granularity,
  Y as PeriodEdgePoint,
  A as PeriodType
};
//# sourceMappingURL=period.types.js.map
